<template>
  <footer class="main-footer">
    <div class="pull-right hidden-xs">
      <b>Version</b> 2.1.0
    </div>
    蓓盈纤 APP Admin &copy; 2017 <a href="#"><strong>蓓盈纤</strong></a>.
  </footer>
</template>

<script>
  export default {
    name: 'DashboardFooter'
  }
</script>




// WEBPACK FOOTER //
// Footer.vue?27b274dc